import Dexie from "dexie";

const db = new Dexie("TecnaviaPushDB");
db.version(1).stores({
    received: "&id",
    config: "&id"
});
db.open();

const add = async (dbName, id, params = {}) => {
    const exists = (await get(dbName, id)) !== undefined;
    if (exists) {
        console.debug(`${dbName} already contains ${id}, try to update`);
        return update(dbName, id, params);
    }
    return db[dbName].add({ id, ...params });
};

const update = async (dbName, id, params = {}) => {
    return db[dbName].update(id, params);
};

const del = async (dbName, id) => {
    return db[dbName].where("id").equals(id).delete();
};

const get = async (dbName, id) => {
    return db[dbName].get(id);
};

const clear = async (dbName) => {
    return db[dbName].clear();
};

export { add, update, del, get, clear };
